import React, { Fragment } from 'react';

import Header from '../../components/header/Header';
import Hero from '../../components/hero/hero';
import FeaturesSection from '../../components/FeaturesSection/FeaturesSection';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';

const HomePage = () => {
    return (
        <Fragment>
            <div className="homePage">
                <Header />
                <main className="page_content">
                    <Hero />
                    <FeaturesSection/>
                </main>
                <Footer />
                <Scrollbar />
            </div>
        </Fragment>
    );
};

export default HomePage;
